/*@ngInject*/
const ReplyCollaborationEmailRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.reply = function (emailId) {
        let url = '/rest/Email/' + emailId + '/reply';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('replyCollaborationEmailRepository', ReplyCollaborationEmailRepository);
